<div class="pdfItem pb-3 mb-1 itemLevel{{level}}" [ngClass]="!imageExists ? 'itemWarning' : ''">
  <div class="row align-items-center PdfItemHeader mb-2" [ngClass]="expandedState == true ? 'expanded' : ''" (mouseover)="hover.emit(item.position)">
    <div class="col-1" (click)="expandedState = !expandedState;tester($event)">
      <span *ngIf="expandedState">▼</span>
      <span *ngIf="!expandedState">▶</span>
    </div>
    <div class="col-7">
      <div class="pdfItemIdentifiers">
        <label>Name:</label>
        <input class="nameInput" [(ngModel)]="item.name" />
      </div>
    </div>
    <div class="col-2">
      <span *ngIf="position != null && position.index != 0" (click)="move(-1)">🡹</span>
      <span *ngIf="position != null && position.index + 1 != position.length" (click)="move(1)">🡻</span>
    </div>
    <div class="col-2 text-right cursor-pointer"><div (click)="removeMe()">slet</div></div>
  </div>

  <!--Type-->
  <div class="row" *ngIf="expandedState == true">
    <div class="col-12 d-flex justify-content-between align-items-center">
      <div class="pdfItemIdentifiers d-flex align-items-center">
        <div>Type:</div>
        <select [ngModel]="item.type" (change)="typeChange($event)">
          <option [ngValue]="null">{{ 'Standard.NoneChosen' | translate }}</option>
          <option disabled><b>Layout object</b></option>
          <option value="columns">Columns</option>
          <option value="stack">List</option>
          <option value="table">Table</option>
          <option value="compositeText">Composite Text</option>
          <option value="absolute">Fixed position</option>
          <option disabled>------------------</option>
          <option disabled><b>Simple object</b></option>
          <option value="text">{{ 'Word.Text' | translate }}</option>
          <option value="image">{{ 'Standard.Image' | translate }}</option>
          <option value="date">{{ 'Standard.Date' | translate }}</option>
          <option value="line">Line</option>
          <option disabled>------------------</option>
          <option disabled><b>Offer object</b></option>
          <option value="productTable">Product Table</option>
          <option value="sumTotal">Product Totals</option>
          <option value="productPage">Product Page</option>
        </select>
      </div>
      <button class="btn btn-sm" [ngClass]="itemMode == 'content' ? 'active btn-primary': 'btn-outline-primary'" (click)="itemMode = 'content'">Options</button>
      <button class="btn btn-sm" [ngClass]="itemMode == 'margins' ? 'active btn-primary': 'btn-outline-primary'" (click)="itemMode = 'margins'">Margins</button>
      <button class="btn btn-sm" [ngClass]="itemMode == 'style' ? 'active btn-primary': 'btn-outline-primary'" (click)="itemMode = 'style'">Style</button>
      <button class="btn btn-sm" [ngClass]="itemMode == 'extra' ? 'active btn-primary': 'btn-outline-primary'" (click)="itemMode = 'extra'">Extra</button>
    </div>
  </div>

  <!--Content-->
  <div class="row align-items-center">
    <div class="col-12" *ngIf="item.type != null && expandedState == true">
      <div class="row" *ngIf="itemMode == 'content'">
        <!--Columns Settings-->
        <div class="col-12 d-flex" *ngIf="item.type == 'columns'">
          <div>Column Gap</div>
          <input class="smallNumber" type="number" [(ngModel)]="item.gap" />
        </div>
        <!--Text Settings-->
        <div class="col-12" *ngIf="item.type == 'text'">
          <div class="row">
            <div class="col-3">
              Text type
            </div>
            <div class="col">
              <select [(ngModel)]="item.textType" (change)="reportChange()">
                <option value="dynamic">Dynamic</option>
                <option value="free">Free</option>
              </select>
            </div>
            <div class="col text-right">
              <button class="btn btn-sm" [ngClass]="item.link != null ? 'btn-success' : 'btn-danger'" (click)="item.link = item.link == null ?  '' : null"><span><i class="fas fa-link"></i></span></button>
            </div>
          </div>
          <div class="row">
            <div class="col-3">Text</div>
            <div class="col-9" *ngIf="item.textType == 'dynamic'">
              <select [(ngModel)]="item.text">
                <option *ngFor="let d of dynamicTextChoices" value="{{d.key}}" (change)="reportChange()" [disabled]="d.key == 'disabled'">{{d.value}}</option>
              </select>
            </div>

            <div class="col-9" *ngIf="item.textType == 'free'">
              <textarea style="width:100%" [(ngModel)]="item.text" (change)="reportChange()"></textarea>
            </div>
          </div>
          <div class="row" *ngIf="item.link != null">
            <div class="col-3">Link</div>
            <div class="col-9">
              <input type="text" class="form-control form-control-sm" [(ngModel)]="item.link" (change)="reportChange()" />
            </div>
          </div>
        </div>
        <!--Image Settings-->
        <div class="col-12 d-flex align-item-center mt-3" *ngIf="item.type == 'image'">
          <div>Fit</div>
          <input class="smallNumber ml-2" type="number" [(ngModel)]="item.fit[0]" (change)="reportChange()"/>
          <input class="smallNumber ml-2" type="number" [(ngModel)]="item.fit[1]" (change)="reportChange()"/>
        </div>
        <div class="col-12 d-flex mt-3" *ngIf="item.type == 'image'">
          <div class="customImages" *ngFor="let im of images" (click)="changeImage(im)" [title]="im.name">
            <img src="https://jubloapi.azure-api.net/api/shared/attachments/{{ im.id }}" alt="Image" class="newImage">
            <div class="ellipsis text-center">{{im.name}}</div>
          </div>
        </div>
        <div class="col-12 mt-3 text-center" *ngIf="item.type == 'image' && !imageExists">
          <h2>Billede <span class="text-light">{{ item.image }}</span> findes ikke. Vælg ny billede eller slet dette objekt.</h2>
        </div>
        <!--Table Settings-->
        <div class="col-12 d-flex align-items-center mt-2 mb-2" *ngIf="item.type == 'table'">
          <div>Line types</div>
          <select [(ngModel)]="item.tableType" (change)="reportChange()">
            <option value="none">No lines</option>
            <option value="header">Only header</option>
            <option value="horizontal">Horizontal Lines</option>
            <option [ngValue]="null">All borders</option>
          </select>
        </div>
        <!--Date Settings-->
        <div class="col-12 d-flex flex-column" *ngIf="item.type == 'date'">
          <div class="mt-2 mb-2">
            Language format
            <select class="form-control-form-control-sm" [(ngModel)]="item.dateSettings.language" (change)="reportChange()">
              <option value="da-DK">Dansk</option>
              <option value="en-US">English</option>
              <option value="es-ES">Español</option>
              <option value="nn-NO">Norsk</option>
              <option value="sv-SE">Svenska</option>
            </select>
          </div>
          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <div class="pr-3">Year</div>
              <select class="form-control form-control-sm" [(ngModel)]="item.dateSettings.year" (change)="reportChange()">
                <option value="2-digit">2-digit</option>
                <option value="numeric">numeric</option>
              </select>
            </div>
            <div class="col-4 d-flex align-items-center">
              <div class="pr-3">Month</div> 
              <select class="form-control form-control-sm" [(ngModel)]="item.dateSettings.month" (change)="reportChange()">
                <option value="2-digit">2-digit</option>
                <option value="numeric">numeric</option>
                <option value="narrow">narrow'</option>
                <option value="short">short</option>
                <option value="long">long</option>
              </select>
            </div>
            <div class="col-4 d-flex align-items-center">
              <div class="pr-3">Day</div> 
              <select class="form-control form-control-sm" [(ngModel)]="item.dateSettings.day" (change)="reportChange()">
                <option value="2-digit">2-digit</option>
                <option value="numeric">numeric</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-12 row mt-2 mb-2 align-items-center" *ngIf="item.type == 'date'">
          <div class="col-1">Type</div>
          <div class="col-6">
            <select class="form-control form-control-sm" [(ngModel)]="item.dateSettings.type" (change)="reportChange()">
              <option value="now">Now</option>
              <option value="nowPlus">Now Plus Days</option>
              <option value="set">Set</option>
            </select>
          </div>
          <div class="col-5">
            <div class="d-flex align-items-center" *ngIf="item.dateSettings.type == 'nowPlus'">
              <div class="pr-3">+</div>
              <input class="form-control form-control-sm" type="text" [(ngModel)]="item.dateSettings.variable" (change)="reportChange()" />
              <div class="pl-3">days</div>
            </div>
            <div class="d-flex" *ngIf="item.dateSettings.type == 'set'">
              <div class="input-group">
                <input type="text"
                       #setDatePick="bsDatepicker"
                       class="form-control"
                       bsDatepicker
                       name="date"
                       placeholder="{{ 'Date.SelectDate' | translate }}"
                       [(ngModel)]="item.dateSettings.variable"
                       [bsConfig]="bsConfig"
                       (bsValueChange)="changeDate($event)">
                <button type="button" class="btn btn-secondary" (click)="setDatePick.toggle()">
                  <i class="far fa-calendar-alt"></i>
                </button>
            </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row pt-2 pb-2" *ngIf="itemMode == 'margins'">
        <div class="d-flex" *ngIf="!!item.margin">
          <div class="col-4 d-flex justify-content-around align-items-center">
            <div>Left</div>
            <input class="smallNumber" type="number" [(ngModel)]="item.margin[0]" (change)="reportChange()" />
          </div>
          <div class="col-4 d-flex justify-content-around align-items-center">
            <div>Top</div>
            <input class="smallNumber" type="number" [(ngModel)]="item.margin[1]" (change)="reportChange()" />
          </div>
          <div class="col-4 d-flex justify-content-around align-items-center">
            <div>Right</div>
            <input class="smallNumber" type="number" [(ngModel)]="item.margin[2]" (change)="reportChange()" />
          </div>
          <div class="col-4 d-flex justify-content-around align-items-center">
            <div>Bottom</div>
            <input class="smallNumber" type="number" [(ngModel)]="item.margin[3]" (change)="reportChange()" />
          </div>
        </div>
        <div class="col-12 text-center" *ngIf="!item.margin">
          <button class="btn btn-success" (click)="item.margin = [0,0,0,0]">Customize the margins on this item</button>
        </div>
      </div>
      <div *ngIf="itemMode == 'style'">
        <div class="row pt-2 pb-1">
          <div class="col-3 d-flex align-items-center">
            <input class="checkbox" type="checkbox" [(ngModel)]="item.bold" (change)="reportChange()" />
            <div>Bold</div>
          </div>
          <div class="col-3 d-flex align-items-center">
            <input class="checkbox" type="checkbox" [(ngModel)]="item.italics" (change)="reportChange()" />
            <div>Italics</div>
          </div>
          <div class="col-5 d-flex">
            <div>Font </div>
            <select [(ngModel)]="item.font" (change)="addFont($event.target.value)">
              <option [ngValue]="null">None</option>
              <option value="Arial">Arial</option>
              <option value="Roboto">Roboto</option>
              <option value="Times">Times New Roman</option>
              <option value="Ubuntu">Ubuntu</option>
              <option value="Verdana">Verdana</option>
            </select>
          </div>
        </div>
        <div class="row pb-2">
          <div class="col-3 d-flex align-items-center">
            <div>Font size</div>
            <input class="smallNumber" type="number" [(ngModel)]="item.fontSize" (change)="reportChange()" />
          </div>
          <div class="col-3 d-flex align-items-center">
            <div>Line height</div>
            <input class="smallNumber" type="number" [(ngModel)]="item.lineHeight" (change)="reportChange()" />
          </div>
          <div class="col-3 d-flex align-items-center">
            <div>Width</div>
            <input class="smallNumber" type="number" [(ngModel)]="item.width" (change)="reportChange()" />
          </div>
          <div class="col-3 d-flex align-items-center">
            <div>Color</div>
            <input class="smallNumber" type="text" [(ngModel)]="item.color" (change)="reportChange()" />
          </div>
          <div class="col-3 d-flex align-items-center">
            <div>Fill Color</div>
            <input class="smallNumber" type="text" [(ngModel)]="item.fillColor" (change)="reportChange()" />
          </div>
          <div class="col-3 d-flex align-items-center">
            <div>Alignment</div>
            <select [(ngModel)]="item.alignment" (change)="reportChange()">
              <option value="left">Left</option>
              <option value="center">Center</option>
              <option value="right">Right</option>
              <option value="justify">Justify</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row align-items-center" *ngIf="itemMode == 'content' && expandedState == true">
    <!--Column Content-->
    <div class="col-12" *ngIf="['columns', 'stack', 'compositeText'].includes(item.type)">
      <div class="innerItem" *ngFor="let x of item.columns; let i = index">
        <app-pdf-item (remove)="item.columns.splice(i,1)"
                      [images]="images"
                      (move)="moveChild( i, $event)"
                      [(item)]="item.columns[i]"
                      [level]="level + 1"
                      [language] = "language"
                      (something)="item.columns[i] = $event;onSimpleChange()"
                      (hover)="hover.emit($event)"
                      [pos]="{ index: i, length:item.columns.length  }"
                      (change)="reportChange()">
        </app-pdf-item>
      </div>
      <div class="row">
        <div class="col-12 text-center" (click)="item.columns.push({name:'new', type:null})">Add new line</div>
      </div>
    </div>
    <!--Table Content-->
    <div class="col-12" *ngIf="item.type == 'table'">
      <table class="tableContent innerItem" aria-label="Pdf item content">
        <thead>
          <th></th>
          <th></th>
        </thead>
        <tr>
          <td class="addColumn">Widths</td>
          <td *ngFor="let x of item.tableWidths; let i = index">
            <input type="number" class="form-control form-control-sm" name="tableWidth{{i}}" [ngModel]="item.tableWidths[i]" (change)="setTableWidth($event.target.value,i)" />
          </td>
          <td class="addColumn" (click)="addTableColumn()">+</td>
        </tr>
        <tr *ngFor="let x of item.tableRows; let xi = index">
          <td class="addColumn" (click)="item.tableRows.splice(xi,1);onSimpleChange()">slet</td>
          <td *ngFor="let y of x; let yi = index" (click)="tableChoice.x = xi; tableChoice.y = yi" [ngClass]="xi == tableChoice.x && yi == tableChoice.y ? 'active' : ''">{{ y.name }}</td>
          <td class="addColumn"></td>
        </tr>
        <tr class="addRow">
          <td class="" (click)="addTableRow()">+</td>
          <td class="" *ngFor="let x of item.tableWidths; let i = index" (click)="removeTableColumn(i)">
            slet
          </td>
          <td class=""></td>
        </tr>
      </table>
      <div class="innerItem mt-2">
        <app-pdf-item (remove)="item.columns.splice(i,1)"
                      [images]="images"
                      [(item)]="item.tableRows[tableChoice.x][tableChoice.y]"
                      (change)="reportChange()">
        </app-pdf-item>
      </div>
    </div>
    <!--Absolute Content-->
    <div class="col-12" *ngIf="item.type == 'absolute'">
      <div>X <input type="number" step="1" [(ngModel)]="item.fit[0]" (change)="onSimpleChange()"/></div>
      <div>Y <input type="number" step="1" [(ngModel)]="item.fit[1]" (change)="onSimpleChange()" /></div>
      <app-pdf-item (remove)="item.columns.splice(i,1)"
                    [images]="images"
                    [(item)]="item.singleItem"
                    (something)="item.singleItem = $event"
                    (change)="onSimpleChange()">
      </app-pdf-item>
    </div>
    <!--Product Table Content-->
    <div class="col-12 d-flex flex-column" *ngIf="item.type == 'productTable'">
      <div class="labeler d-flex align-items-center">
        <div class="label">{{ 'Standard.Quantity' | translate }}</div>
        <input type="text" [(ngModel)]="item.translates.amount" (change)="onSimpleChange()" />
      </div>
      <div class="labeler d-flex align-items-center">
        <div class="label">{{ 'Standard.Price' | translate }} / {{ 'Standard.Quantity' | translate }}</div>
        <input type="text" [(ngModel)]="item.translates.pricePer" (change)="onSimpleChange()" />
      </div>
      <div class="labeler d-flex align-items-center">
        <div class="label">{{ 'Standard.Description' | translate }}</div>
        <input type="text" [(ngModel)]="item.translates.text" (change)="onSimpleChange()" />
      </div>
      <div class="labeler d-flex align-items-center">
        <div class="label">{{ 'Standard.Discount' | translate }}</div>
        <input type="text" [(ngModel)]="item.translates.discount" (change)="onSimpleChange()" />
      </div>
      <div class="labeler d-flex align-items-center">
        <div class="label">{{ 'Standard.Price' | translate }}</div>
        <input type="text" [(ngModel)]="item.translates.price" (change)="onSimpleChange()" />
      </div>
      <div class="labeler d-flex align-items-center">
        <div class="label">{{ 'Standard.Quantity' | translate }}</div>
        <input type="text" [(ngModel)]="item.translates.hourPlusStartUp" (change)="onSimpleChange()" />
      </div>
      <div class="labeler d-flex align-items-center">
        <div class="label">Produktnr. </div>
        <input type="text" [(ngModel)]="item.translates.productNumber" (change)="onSimpleChange()" />
        <div class="d-flex align-items-center ml-3">
          <div>{{ 'Standard.Show' | translate }}</div>
          <input class="ml-2" type="checkbox" [(ngModel)]="item.translates.useArticleNumber" (change)="tester(item)" />
        </div>
      </div>
      <div class="labeler d-flex align-items-center mt-3">
        <div class="label">Fake diverse linje</div>
        <input type="text" [(ngModel)]="item.translates.fakeDifferenceLine" (change)="onSimpleChange()" *ngIf="item.translates.fakeDifferenceLine != null" />
        <button class="btn btn-sm btn-danger ml-2" *ngIf="item.translates.fakeDifferenceLine" (click)="deleteFakeLine()">Remove fake line</button>
        <button class="btn btn-sm btn-danger ml-2" *ngIf="!!item.translates.fakeDifferenceLine" (click)="item.translates['fakeDifferenceLine'] = '';onSimpleChange()">Add fake line</button>
      </div>
      <div class="labeler d-flex align-items-center mt-3">
        <button class="btn" [ngClass]="item.tableType == null ? 'btn-danger' : 'btn-outline-danger'" (click)="addTableType('')">Standard</button>
        <button class="btn" [ngClass]="item.tableType != null && item.tableType == 'none' ? 'btn-success' : 'btn-outline-success'" (click)="addTableType('none')">Inga linier</button>
        <button class="btn" [ngClass]="item.tableType != null && item.tableType == 'header' ? 'btn-success' : 'btn-outline-success'" (click)="addTableType('header')">Kun linie i header</button>
        <button class="btn" [ngClass]="item.tableType != null && item.tableType == 'horizontal' ? 'btn-success' : 'btn-outline-success'" (click)="addTableType('horizontal')">Tynne linier</button>
      </div>
      <div class="d-flex align-items-center mt-3">
        Skjul alle priser
        <input class=" ml-3" type="checkbox" [(ngModel)]="item.translates.hideAllPrices" (change)="onSimpleChange()">
      </div>
      <div class="d-flex align-items-center mt-3">
        Skjul priser som ikke er gruppe
        <input class=" ml-3" type="checkbox" [(ngModel)]="item.translates.hideLinePrices" (change)="onSimpleChange()">
      </div>
    </div>
    <!--Product Sum Content-->
    <div class="col-12 d-flex" *ngIf="item.type == 'sumTotal'">
      <select [(ngModel)]="item.totalType">
        <option value="normal">Normal</option>
        <option value="reduction">Reduktion</option>
      </select>
    </div>
    <!-- Product Page Content -->
    <div class="col-12 d-flex" *ngIf="item.type == 'productPage'">
      <div class="labeler d-flex align-items-center">
        <div class="label">Ny side</div>
        <input class="ml-2" type="checkbox" [checked]="!!item.pageBreak && item.pageBreak != 'none'" (change)="changePageBreak($event)" />
        <select class="form-control form-control-sm ml-2" [(ngModel)]="item.pageBreak" *ngIf="item.pageBreak != 'none'">
          <option value="before">Før</option>
          <option value="after">Efter</option>
        </select>
      </div>
    </div>
  </div>
  <div class="row align-items-center" *ngIf="itemMode == 'extra' && expandedState == true">
    <div class="col mt-2">
      <button class="btn btn-sm btn-primary" (click)="addCondition()"  *ngIf="!item.condition"> <span>Add condition</span></button>
      <button class="btn btn-danger btn-sm" (click)="removeCondition()" *ngIf="!!item.condition"><span>Remove condition</span></button>
      <select class="form-control form-control-sm" [(ngModel)]="item.condition" *ngIf="!!item.condition">
        <option value="'none'">{{ 'Standard.NoneChosen' | translate }}</option>
        <option *ngFor="let con of conditionChoices" value="{{con.key}}">{{con.value}}</option>
      </select>
    </div>
    <div class="col-12" *ngIf="level == 1">
      <button class="btn btn-primary" (click)="makeUnbreak()" *ngIf="!item.unbreakable">Make unbreakable</button>
      <button class="btn btn-secondary" (click)="makeBreak()" *ngIf="!!item.unbreakable">Make breakable</button>
    </div>
    <div class="col-12 flex-between mt-3" *ngIf="level == 1">
      <div class="mr-3">Sideskift</div>
      <select class="form-control form-control-sm" [(ngModel)]="item.pageBreak" (change)="reportChange()">
        <option [ngValue]="null">Ingen sideskift</option>
        <option value="before">Før</option>
        <option value="after">Efter</option>
      </select>
    </div>
  </div>
</div>

